/* eslint-disable */
// Barrel re-export of all Topshop-specific Sitecore things:
// - JSS component registrations (customer-care, sierra-chat, nuance-chat dependencies)
// - Layout-level components used only in Topshop layouts
// - Icons, search utilities used only in Topshop
// Must not be imported by other apps.

// --- JSS component builder registrations ---
export * as FAQAttachments from "./components/customer-care/components/attachments/attachments";
export * as FaqHeader from "./components/customer-care/components/faq-header/faq-header";
export * as HighlightBlock from "./components/customer-care/components/highlight-block/highlight-block";
export * as FAQContent from "./components/customer-care/components/faq-content/FAQContent";
export * as ImageList from "./components/customer-care/components/links-images/links-images";
export * as ContactUs from "./components/customer-care/components/get-in-touch/contact-us";
export * as GetInTouchContent from "./components/customer-care/components/get-in-touch/content";
export * as GetInTouchActionButtons from "./components/customer-care/components/get-in-touch/action-buttons";
export * as ProductGrid from "./components/editorial/product-grid/product-grid";
export { SearchField } from "./components/customer-care/components/search";
export * as HelpTopicList from "./components/customer-care/components/help-topic-list/help-topic-list";

// --- Layout components ---
export { default as FAQLayout } from "./components/customer-care/customer-care";
export { default as VersionNumber } from "./components/version-number/version-number";
export { ChatbotContextProvider } from "./components/providers/chatbot-provider";

// --- Icons ---
export { ArrowR } from "./components/icons/index";

// --- Search utilities ---
export * from "./components/customer-care/components/search/search-context";
export { searchApi } from "./components/customer-care/components/search/api/search";
